import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardActionArea } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { calculateTwoFullDate } from '../../utils/date';
const useStyles = makeStyles({
  card: {
    padding: '3% 2%',
    margin: '1%'
  },
  title: {
    fontSize: 14
  },
  avatarImg: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 5,
    width: 50,
    height: 50,
    borderRadius: '50%'
  }
});

function OneLoan({ loan, history }) {
  const classes = useStyles();

  const goToDetail = id => {
    history.push(`loan_detail?loan_id=${id}`);
  };

  return (
    <Card className={classes.card}>
      <CardActionArea
        className={classes.actionArea}
        onClick={() => {
          goToDetail(loan.id);
        }}
      >
        <div style={{ display: 'flex' }}>
          <img className={classes.avatarImg} alt='ad-img' src={loan.account_logo} />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              width: '90%',
              marginLeft: '5%'
            }}
          >
            <div style={{ display: 'flex', fontSize: 22 }}> {loan.account_name}</div>
            <div style={{ display: 'flex', fontSize: 14, justifyContent: 'space-between' }}>
              <div>Open: {loan.open_date}</div>
              <div>Maturity: {loan.maturity_date}</div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: 17 }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-around',
              alignItems: 'center'
            }}
          >
            <div style={{ fontSize: 17, marginBottom: 10 }}>
              {parseFloat((loan.interest_rate * 100).toFixed(3)) + '%'}
            </div>
            <div style={{ color: '#6e6f6f' }}>Interest Rate</div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-around',
              alignItems: 'center'
            }}
          >
            <div style={{ fontSize: 17, marginBottom: 10 }}>{'$' + parseFloat(loan.current_balance.toFixed(2))}</div>
            <div style={{ color: '#6e6f6f' }}>Current Balance</div>
          </div>{' '}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-around',
              alignItems: 'center'
            }}
          >
            <div style={{ fontSize: 17, marginBottom: 10 }}>{calculateTwoFullDate(loan.maturity_date)}</div>
            <div style={{ color: '#6e6f6f' }}>Days To Maturity</div>
          </div>
        </div>
      </CardActionArea>
    </Card>
  );
}
export default withRouter(OneLoan);
